<template>
  <adv-button
    class="addtoCart"
    v-on:btn-click="buttonClick"
    :disabled="disabled"
    :productId="this.productId"
    :quantity="this.quantity"
    v-html="buttonText"></adv-button>
</template>

<script>
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'

export default {
  name: 'AdvCartButton',
  components: {
    AdvButton
  },
  mixins: [onlineMixin, cartButtonMixin],
  props: {
    productId: Number,
    quantity: {
      type: Number,
      default: 0
    },
    stock: {
      type: Number,
      default: 1
    },
    unavailable: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    },
    cartLimitReached: {
      type: Boolean,
      default: false
    },
    hasAttributes: {
      type: Boolean,
      default: false
    },
    hasSimilarEntries: {
      type: Boolean,
      default: false
    },
    selectedAttributeId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  methods: {
    buttonClick () {
      if (this.stock > 0) {
        this.$emit('btn-click')
      } else {
        this.$emit('btn-click-no-stock')
      }
    }
  }
}
</script>
